"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EditActionsGroupRow = (props) => {
    const { myUserGroup, rightsholderUser } = props;
    return (react_1.default.createElement("p", null,
        react_1.default.createElement("span", null,
            myUserGroup.checked ? 'Add' : 'Removing',
            "\u00A0"),
        react_1.default.createElement("strong", { title: rightsholderUser.firstName + ' ' + rightsholderUser.lastName },
            rightsholderUser.firstName,
            " ",
            rightsholderUser.lastName),
        react_1.default.createElement("span", null,
            "\u00A0",
            myUserGroup.checked ? 'to' : 'from',
            "\u00A0"),
        react_1.default.createElement("strong", null, myUserGroup.name)));
};
exports.default = EditActionsGroupRow;
